import locationzoneCreateComponent from './location_zone.create.component';

let locationzoneCreateModule = angular.module('locationZoneCreate', [])

    .component('locationZoneCreate', locationzoneCreateComponent)

    .name;

export default locationzoneCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/create/index.js